import { IApplicationState } from '../../types/redux';
import { getBuilderChatEnabled } from '../builderChat';
import { selectConsultantMessageButtonAvailable } from '../consultantChat';

export const selectMessageButtonAvailable = (state: IApplicationState): boolean => {
  const isBuilderChatButtonAvailable = getBuilderChatEnabled(state);
  const isConsultantChatButtonAvailable = selectConsultantMessageButtonAvailable(state);

  return isBuilderChatButtonAvailable || isConsultantChatButtonAvailable;
};
